// @flow
import baseMemoize from 'lodash/fp/memoize';

export type Memoize = <Args, R>(
  (...Args) => R,
  void | ((...Args) => any),
) => (...Args) => R;

// The lodash FP Guide says that memoize has a fixed arity of one.
// This allows us to have a resolver.
// see https://github.com/lodash/lodash/issues/3321 for more
export const memoize: Memoize = (baseMemoize: any).convert({ fixed: false });

export const simpleMemoize = <A, R>(f: (A) => R): ((A) => R) => memoize(f);
